// Angular
import { Injectable } from '@angular/core';

// ABP
import { RestService, ABP, LocalizationService } from '@abp/ng.core';

// Others
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LocalizationExtendService {
  
    constructor(private localizationService: LocalizationService) { }

    async getLocalization(key: string): Promise<string> {
        return (await new Observable((subscribe) => {
          this.localizationService.get(key).subscribe(res=> {
            subscribe.next(res);
            subscribe.complete();
          }) 
        }).toPromise()) as string;
      }
}